import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';

const ActionButton = ({ 
  children, 
  onClick, 
  variant = 'primary', 
  disabled = false, 
  icon,
  loading = false,
  className = '',
  ...props 
}) => {
  const baseClasses = "w-full py-4 px-6 rounded-2xl font-bold text-lg transition-all duration-300 flex items-center justify-center space-x-3 focus:outline-none focus:ring-4";
  
  const variants = {
    primary: `${baseClasses} bg-gradient-to-r from-brand-orange to-brand-primary text-brand-white hover:from-brand-primary hover:to-brand-orange focus:ring-brand-orange/30 shadow-lg hover:shadow-xl`,
    secondary: `${baseClasses} bg-brand-white text-brand-primary border-2 border-brand-primary hover:bg-brand-cream focus:ring-brand-primary/20`,
    ghost: `${baseClasses} bg-transparent text-brand-primary hover:bg-brand-cream focus:ring-brand-primary/10`
  };

  const disabledClasses = "opacity-50 cursor-not-allowed";

  return (
    <motion.button
      whileHover={!disabled ? { scale: 1.02 } : {}}
      whileTap={!disabled ? { scale: 0.98 } : {}}
      onClick={onClick}
      disabled={disabled || loading}
      className={`${variants[variant]} ${disabled ? disabledClasses : ''} ${className}`}
      {...props}
    >
      {loading ? (
        <motion.div
          animate={{ rotate: 360 }}
          transition={{ duration: 1, repeat: Infinity, ease: "linear" }}
          className="w-6 h-6 border-2 border-current border-t-transparent rounded-full"
        />
      ) : (
        <>
          {icon && <SafeIcon icon={icon} className="text-xl" />}
          <span>{children}</span>
        </>
      )}
    </motion.button>
  );
};

export default ActionButton;